module.exports = __webpack_public_path__ + "img/structure.8da5bfaf.svg";